enum SelectionOption {
  Dell,
  Skip,
  Customer,
}

export default SelectionOption;
